'use client'

import {useEffect, useState} from 'react'

const PORTAL_ROOT_ID = 'fitro-overlay-root'

const resolvePortalRoot = (): HTMLElement | null => {
    if (typeof document === 'undefined') return null

    const element = document.getElementById(PORTAL_ROOT_ID)
    return element instanceof HTMLElement ? element : null
}

export const usePortalContainer = (): HTMLElement | null => {
    const [container, setContainer] = useState<HTMLElement | null>(() => resolvePortalRoot())

    useEffect(() => {
        setContainer(resolvePortalRoot())
    }, [])

    return container
}

export const getPortalRootDiagnostics = () => {
    const portalRoot = resolvePortalRoot()

    return {
        portal_root_present: Boolean(portalRoot),
        portal_root_child_count: portalRoot ? portalRoot.childElementCount : null,
    }
}
